import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ControlledSelectInput from '../../../../components/custom-inputs/ControlledSelectInput';
import { countriesSorted } from '../../../../utils/helpers';
import ControlledAutocompleteInput from '../../../../components/custom-inputs/ControlledAutocompleteInput';

interface JurisdictionAccordionProps {
  disabled?: boolean;
}

const JurisdictionForm = ({ disabled = false }: JurisdictionAccordionProps) => {
  const { t } = useTranslation();
  return (
    <Stack width="50%" alignItems="start">
      <ControlledAutocompleteInput
        name="body.jurisdiction"
        defaultValue={null}
        label={t('common.country')}
        translation={{ t, ns: 'enum' }}
        required
        fullWidth
        placeholder={t('common.selectCountry')}
        disabled={disabled}
        choices={countriesSorted()}
        sx={{ width: '100%' }}
      />
    </Stack>
  );
};

export default JurisdictionForm;
